import EventEmitter from "events";
import { AnimationAction, LoopOnce, LoopRepeat } from "three";

interface AnimationOptions {
  duration: number;
  loop: boolean;
}

export default class Animation extends EventEmitter {
  //---- Animation ----
  protected oldAction!: AnimationAction;
  protected newAction!: AnimationAction;
  protected animations: { [name: string]: AnimationAction };

  constructor(animations: { [name: string]: AnimationAction }) {
    super();
    this.animations = animations;
  }

  play(name: string, options?: Partial<{ duration: number, loop: boolean }>): void {
    //이전 애니메이션과 같은 애니메이션일 경우 실행하지 않음.
    const defaultOptions: AnimationOptions = { duration: 0.2, loop: false };
    const { duration, loop } = { ...defaultOptions, ...options };
    if (this.newAction) this.oldAction = this.newAction;
    this.newAction = this.animations[name];
    // 애니메이션이 존재하지 않는 경우 에러 처리
    if (!this.newAction) {
      console.error(`❌ Animation not found: ${name}. Available animations:`, Object.keys(this.animations));
      return;
    }

    this.newAction.loop = loop ? LoopRepeat : LoopOnce;

    if (this.newAction?.getClip().name === this.oldAction?.getClip().name) return;

    if (this.oldAction) this.newAction.reset().play().crossFadeFrom(this.oldAction, duration, false);
    else this.newAction.reset().play().fadeIn(duration);
  }

  resume(): void {
    if (!this.newAction) return;
    this.newAction.paused = false;
  }

  pause(): void {
    if (!this.newAction) return;
    this.newAction.paused = true;
  }

  stop(): void {
    if (!this.newAction) return;
    this.newAction.stop();
  }
}